<template>
    <div class='form-group'>
        <label>Event Type:</label>
        <div class='checkbox'>
            <label>
                <input type='checkbox' v-model='value.meeting' @change='emitChange()' />
                Meetings ({{countByMeeting(events)}} {{countByMeeting(events)==1?'event':'events'}})
            </label>
        </div>
        <div class='checkbox'>
            <label>
                <input type='checkbox' v-model='value.course' @change='emitChange()' />
                Courses <span v-show='value.course'>of type:</span>
            </label>
            <select class='form-control' v-model='value.sectypecode' v-show='value.course' @change='emitChange()'>
                <option value=''>All Courses ({{countByAcademic(events)}} {{countByAcademic(events)==1?'event':'events'}})</option>
                <option v-for='(sectype,sectypecode) in sectypes' v-bind:key='sectypecode' v-bind:value='sectypecode'>
                    {{sectype.description}} ({{countBySecType(events,sectypecode)}} {{countBySecType(events,sectypecode)==1?'event':'events'}})
                </option>
            </select>
        </div>
    </div>
</template>

<script>
import Event from '../model/Event';
export default {
    name: 'event-type-filter',
    data() {
        return {
            sectypes: Event.SECTIONTYPES
        };
    },
    props: {
        events: {
            type: Array,
            default() {
                return [];
            }
        },
        value: {
            type: Object,
            default() {
                return {
                    meeting: true,
                    course: true,
                    sectypecode: ''
                };
            }
        }
    },
    methods: {
        countByAcademic: Event.countByAcademic,
        countByMeeting: Event.countByMeeting,
        countBySecType: Event.countBySecType,
        emitChange() {
            this.$emit('input', this.value);
        }
    }
};
</script>

<style scoped>
form label {
    margin-right: 4px;
    margin-left: 5px;
}
</style>